import { GuestDetailsActionTypes } from '../actions';
import { PassengerCruiseSurvey } from '../models/cruise-survey';

export interface State {
  passengerCruiseSurveys: PassengerCruiseSurvey[];
  cruiseSurveySaved: boolean | null;
  status: any,
  errors: any
}

export const initialState: State = {
  passengerCruiseSurveys: [],
  cruiseSurveySaved: null,
  status: null,
  errors: null
};

export function reducer(state = initialState, action: any): State {
  switch(action.type) {
    case GuestDetailsActionTypes.POST_RETRIEVE_CRUISE_SURVEY_SUCCESS: {
      return { ...state, passengerCruiseSurveys: action.payload };
    }
    case GuestDetailsActionTypes.POST_RETRIEVE_CRUISE_SURVEY_FAILURE: {
      return { ...state, errors: action.payload };
    }
    case GuestDetailsActionTypes.POST_SAVE_CRUISE_SURVEY_SUCCESS: {
      return { ...state, cruiseSurveySaved: true };
    }
    case GuestDetailsActionTypes.POST_SAVE_CRUISE_SURVEY_FAILURE: {
      return { ...state, cruiseSurveySaved: false };
    }
    default: {
      return state;
    }
  }
}

export const getPassengerCruiseSurveys = (state: State) => state.passengerCruiseSurveys;
